import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import axios from "../../services/api";
import { Helmet } from "react-helmet";
import "./styles/ResetPassword.css";

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [form, setForm] = useState({
    email: "",
    token: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    if (!email || !token) {
      setError("Səhv link. Zəhmət olmasa yenidən sıfırlama tələb edin.");
      return;
    }

    const fixedToken = decodeURIComponent(token.replace(/ /g, "+"));

    setForm((prev) => ({
      ...prev,
      email: decodeURIComponent(email),
      token: fixedToken,
    }));
  }, [searchParams]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (error) setError("");
    if (success) setSuccess("");
  };

  const validatePassword = () => {
    if (form.newPassword.length < 6) {
      setError("Şifrə ən azı 6 simvol olmalıdır.");
      return false;
    }

    if (form.newPassword !== form.confirmPassword) {
      setError("Şifrələr uyğun gəlmir.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!validatePassword()) return;

    setLoading(true);

    try {
      await axios.post("/account/reset-password", {
        email: form.email,
        token: form.token,
        newPassword: form.newPassword,
      });

      setSuccess("Şifrə uğurla yeniləndi. Giriş səhifəsinə yönləndirilirsiniz...");

      setTimeout(() => {
        navigate("/giris");
      }, 2000);
    } catch (err) {
      const serverError = err.response?.data;

      if (typeof serverError === "string") {
        setError(serverError);
      } else if (err.response?.status === 400) {
        setError("Şifrə sıfırlama linki etibarsızdır. Yenidən sıfırlama tələb edin.");
      } else {
        setError("Xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rp-page">
      <Helmet>
        <title>Şifrə Sıfırlama – HeyatYolu</title>
        <meta name="description" content="HeyatYolu hesabınızın şifrəsini yeniləyin." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="rp-container">
        <div className="rp-card">

          <div className="rp-header">
            <div className="rp-icon">
              <i className="fas fa-key"></i>
            </div>
            <h1 className="rp-title">Şifrə Sıfırlama</h1>
            <p className="rp-subtitle">Yeni şifrə yaradın</p>
          </div>

          <form onSubmit={handleSubmit} className="rp-form">

            <div className="rp-form-group">
              <label htmlFor="newPassword" className="rp-form-label">
                <i className="fas fa-lock"></i>
                Yeni Şifrə
              </label>
              <div className="rp-password-wrapper">
                <input
                  id="newPassword"
                  type={showPassword ? "text" : "password"}
                  name="newPassword"
                  placeholder="••••••"
                  required
                  value={form.newPassword}
                  onChange={handleChange}
                  className="rp-form-input"
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="rp-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                </button>
              </div>
            </div>

            <div className="rp-form-group">
              <label htmlFor="confirmPassword" className="rp-form-label">
                <i className="fas fa-lock"></i>
                Şifrəni Təsdiqləyin
              </label>
              <div className="rp-password-wrapper">
                <input
                  id="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="••••••"
                  required
                  value={form.confirmPassword}
                  onChange={handleChange}
                  className="rp-form-input"
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="rp-password-toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <i className={`fas ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                </button>
              </div>
            </div>

            {error && (
              <div className="rp-error-message">
                <i className="fas fa-exclamation-circle"></i>
                <span>{error}</span>
              </div>
            )}

            {success && (
              <div className="rp-success-message">
                <i className="fas fa-check-circle"></i>
                <span>{success}</span>
              </div>
            )}

            <button type="submit" className="rp-button" disabled={loading}>
              {loading ? (
                <>
                  <span className="rp-spinner"></span>
                  Şifrə yenilənir...
                </>
              ) : (
                <>
                  <i className="fas fa-check"></i>
                  Şifrəni Yenilə
                </>
              )}
            </button>
          </form>

          <div className="rp-back-section">
            <p>
              Giriş səhifəsinə qayıtmaq istəyirsiniz?
              <Link to="/giris" className="rp-back-link">Daxil ol</Link>
            </p>
          </div>
        </div>

        <div className="rp-decoration">
          <div className="rp-decoration-circle rp-circle-1"></div>
          <div className="rp-decoration-circle rp-circle-2"></div>
          <div className="rp-decoration-circle rp-circle-3"></div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;